<template>
  <div class="date_picker">
    <van-cell
      class="after_field_border"
      is-link
      :value="dateFormat"
      :title="title"
      @click="onShow"
    />
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Cell, DatetimePicker, Popup } from 'vant'
import { formatDate, weekDay } from '@/utils/index'

export default {
  name: 'DatePicker',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  components: {
    [Cell.name]: Cell,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup
  },
  props: {
    value: {
      type: String
    },
    showWeek: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '时间'
    }
  },
  watch: {
    // 此处监听variable变量，当期有变化时执行
    value (item1, item2) {
      // item1为新值，item2为旧值
      this.currentDate = new Date(item1)
      this.showCellValue()
      console.log(item1, item2)
    }
  },
  data () {
    return {
      show: false,
      dateFormat: '',
      minDate: new Date(1960, 1, 1),
      maxDate: new Date(2050, 12, 31),
      currentDate: new Date()
    }
  },
  created () {
    this.currentDate = this.value ? new Date(this.value) : new Date()
    this.showCellValue()
  },
  methods: {
    onShow () {
      this.show = true
    },
    onConfirm (value) {
      this.show = false
      let date = formatDate(value)
      this.showCellValue()
      this.$emit('confirm', date)
    },
    showCellValue () {
      if (this.showWeek) {
        this.dateFormat = formatDate(this.currentDate) + '(' + weekDay(this.currentDate) + ')'
      } else {
        this.dateFormat = formatDate(this.currentDate)
      }
    },
    onCancel () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
